import "./Termos.css";
const Termos = () => {
  return (
    <div className="termos_container">
      <h2>Sobre nós</h2>
      <p>
        Estava a estudar e pensar como poderia aplicar meus conhecimentos ao
        mundo virtual e real constantemente, depois de estudar muito, decidir
        começar a aplicar meus conhecimentos em templates e landding pages,
        assim mostrar meus valores ao mundo, e ao mesmo tempo ajudar quem não
        sabe a encontrar, fazer ou hospedar seu mini site rapidamente, algo que
        possa ajudar seu negócio, isso me inspiro a cada dia, e ainda com um
        custo beneficio que não compra nem uma pizza hoje em dia.{" "}
      </p>
      <p>
        Nossos templates e landing pages apesar de baratas são desenvolvidos com
        tecnologia presente no mercado de trabalho profissional.
      </p>

      <h2> Termos de Uso</h2>
      <p className="text_terms">
        1.Do Objeto<br></br> Essa plataforma tem como finalidade de
        vender produtos em conjunto com prestação de serviços, ou seja, disponibilizar a venda de produtos e serviços
        online disponibilizados na nossa plataforma ou aplicativo.
      </p>
      <p className="text_terms">
        2.Da compra do produto<br></br>
        2.1 O nosso website trabalha com templates já prontos, após a compra não
        te da o direito exclusivo do template ou site, nosso website DiDeveloper
        vai continuar utilizando o mesmo para venda e fazendo modificações.
        <br></br>
        2.2 O fato de ter adquirido o produto não dar o direito de ser exclusivo
        do comprador, vamos continuar vendendo o layout com modificações, sem
        suas imagens e marcas resgistradas.
      </p>
      <p className="text_terms">
        3. Formas de pagamento<br></br>
        3.1 As formas de pagamento aceitas em nossas negociações são
        transferência bancaria , PIX, ou boleto bancário.
        <br></br>
        3.2 O boleto bancário poderá ser emitido no momento em que você fizer o
        requisito na nossa negociação.
        <br></br>
        3.1 O boleto tem vencimento na data exposta no mesmo, não sendo aceito
        após a data de vencimento.
        <br></br>
        3.2 Se o boleto vencer e o pagamento não tiver sido efetuado, na
        negociação podemos gerar um novo para você.
        <br></br>
        3.3 O produto terá inicio nas modificações assim que o pagamento da
        entrada de 50%, for confirmada.
        <br></br>
        3.4 Qualquer outra forma de pagamento não é aceita por nosso site.
      </p>
      <p className="text_terms">
        4. Entrada e Entrega<br></br>
        4.1 O produto será hospedado no netlify ou a hospedagem que você
        preferir, e entregue o código após o pagamento final for confirmado.
        <br></br>
        4.2 Os custos e tempo gasto do serviço são cobrados na entrada de %50 do
        valor total do produto.
      </p>
      <p className="text_terms">
        5. Desistência e Reembolso.<br></br>
        5.1 O cliente poderá desistir a qualquer momento.
        <br></br>
        5.2 Pedido de reembolso e desistência efetuado na negociação antes do
        inicio do serviço e das modificações iniciais fazemos o reembolso total
        de 100% da entrada e não entregamos o produto, template, mini site,
        site.
        <br></br>
        5.3 Pedido de reembolso e desistência efetuado depois do inicio do
        serviço e das modificações fazemos o reembolso de 50% do valor da
        ENTRADA, pelo tempo do serviço gasto e não entregamos o produto,
        template, mini site, site.
        <br></br>
        5.4 Pedido de reembolso e desistência efetuado depois do serviço ser
        completo, de todas as modificações e limites estabelecidos serem
        compridos e feitos, não retornaremos nenhum reembolso já que o serviço
        foi feito por completo, e para receber o serviço junto com o produto,
        template, mini site, site, deve confirmar o pagamento final.
        <br />
        5.5 Pedido de reembolso e desistência após a entrega do template, site, mini site, código e dos serviços, modificações feitos e completos, não faremos o reembolso por se tratar de algo já feito e usado após a entrega do mesmo.
      </p>
      <p className="text_terms">
        6. Limites e modificações<br></br>
        6.1 Após efetuar um pedido na negociação conosco você tem direito a 1 modificação geral com cores, remoção de algum elemento na página, textos e imagens, exceto o layout e o tamanho do mesmo.<br></br>
        6.2 Após a primeira modificação, deixamos mais uma modificação extra para realizar nova modificação caso necessário. <br></br>
        6.3 Após o pagamento final do produto e entrega a modificação extra será excluída caso não usada.<br></br>
        6.4 Ao atingir o limite de modificações será cobrada a mais cada nova modificação feita.
      </p>
      <p className="text_terms">
        7. Hospedagem e código.<br></br>
        7.1 Usamos a hospedagem do netlify, inicialmente te entrega de graça 100GB mensal gratís de largura de banda, caso atinja o limite você deve verificar outros planos ou hospedagem de sua preferência. (sujeito a mudanças de limites do site, verifique os limite no site netlify).<br></br>
        7.2 Ao hospedar seu site, template ou mini site, você recebe um domínio gratís do netlify, caso ache necessário um personalizado devera comprar um domínio.<br></br>
        7.3 Após entregarmos o seu template, site, ou mini site você é responsavel pelo seu código e o gerencimento do mesmo, caso haja cobrança a mais em outros serviços não seremos responsaveis.<br></br>
      </p>
    </div>
  );
};

export default Termos;
